"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Application = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TypeUtils_1 = require("../../../common/TypeParsing/TypeUtils");
const TypeStructureComponent_1 = require("./TypeStructureComponent");
const HashMatrix_1 = __importDefault(require("./ValueProcessing/HashMatrix"));
const List_1 = require("./List");
const Navigation_1 = require("./Navigation");
const styled_components_1 = __importDefault(require("styled-components"));
const ApplicationBase = styled_components_1.default.div `
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 1em;
  overflow: hidden;
`;
const HeaderBase = styled_components_1.default.div `
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: center;
  gap: 1em;
`;
const Application = ({ typeStructureMap, value, entryType, onChange, keepNavigationHistory = false, }) => {
    const typeStructure = (0, react_1.useMemo)(() => typeStructureMap[entryType], [typeStructureMap, entryType]);
    const { trail, path, onNavigateTo, onNavigateBack, onSetTrail } = (0, Navigation_1.useNavigation)(keepNavigationHistory);
    const hashMatrix = (0, react_1.useMemo)(() => new HashMatrix_1.default({
        hashMatrix: value,
    }), [value]);
    const currentValue = (0, react_1.useMemo)(() => hashMatrix.getPath(path.map((p) => `${p}`)), [hashMatrix, path]);
    const currentTypeStructure = (0, react_1.useMemo)(() => (0, TypeUtils_1.getTypeStructureByPath)(path, typeStructure, typeStructureMap), [path, typeStructure, typeStructureMap]);
    const tStructIsPrimitive = (0, react_1.useMemo)(() => (0, TypeUtils_1.getTypeStructureIsPrimitive)(currentTypeStructure), [currentTypeStructure]);
    const { multiple: currentTypeIsMultiple = false } = currentTypeStructure;
    const currentValueIsItemInList = (0, react_1.useMemo)(() => {
        const { isListItem = false } = trail[trail.length - 1] || {};
        return isListItem;
    }, [trail]);
    const onChangeInternal = (0, react_1.useCallback)((name, value) => {
        const stringNav = path.map((p) => `${p}`);
        const targetPath = !!name && !tStructIsPrimitive ? [...stringNav, name] : stringNav;
        hashMatrix.setPath(targetPath, value);
        onChange(hashMatrix.getValue());
    }, [hashMatrix, path, onChange, tStructIsPrimitive]);
    const onListChange = (0, react_1.useCallback)((value) => {
        hashMatrix.setPath(path.map((p) => `${p}`), value);
        onChange(hashMatrix.getValue());
    }, [hashMatrix, path, onChange]);
    return ((0, jsx_runtime_1.jsxs)(ApplicationBase, { children: [trail.length > 0 ? ((0, jsx_runtime_1.jsx)(HeaderBase, { children: (0, jsx_runtime_1.jsx)(Navigation_1.NavigationBreadcrumbs, { trail: trail, onChange: onSetTrail }) })) : undefined, currentTypeIsMultiple && !currentValueIsItemInList ? ((0, jsx_runtime_1.jsx)(List_1.List, { typeStructure: currentTypeStructure, typeStructureMap: typeStructureMap, items: currentValue, onChange: onListChange, onNavigateToPath: onNavigateTo, onNavigateBack: onNavigateBack })) : ((0, jsx_runtime_1.jsx)(TypeStructureComponent_1.TypeStructureComponent, { typeStructureMap: typeStructureMap, typeStructure: currentTypeStructure, value: currentValue, onChange: onChangeInternal, onNavigateToPath: onNavigateTo, onNavigateBack: onNavigateBack, topLevel: true, isEntryPoint: trail.length === 0 }))] }));
};
exports.Application = Application;
